/** Кольори напрямів (прототип v4 AREA_PALETTE): діти успадковують колір найближчого предка з власним кольором. */
export const AREA_PALETTE: readonly string[] = ['#1f4ebc', '#0f766e', '#1f8a5b', '#65a30d', '#b7791f', '#c2410c', '#be123c', '#a21caf', '#6b3fd1', '#475569'];
